'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const FileAttachmentIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="FileAttachmentIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Email-Attachment-Document--Streamline-Core"
      >
        <desc>Email Attachment Document Streamline Icon: https://streamlinehq.com</desc>
        <g id="email-attachment-document--mail-send-email-attachment-file-paperclip">
          <path
            id="Subtract"
            fill="#d7e0ff"
            fillRule="evenodd"
            d="M2.43934 0.43934C2.72064 0.158035 3.10218 0 3.5 0H10c0.1326 0 0.2598 0.0526784 0.3536 0.146447l3.5 3.500003C13.9473 3.74021 14 3.86739 14 4v8.5c0 0.3978 -0.158 0.7794 -0.4393 1.0607S12.8978 14 12.5 14H6.719c0.61486 -0.3412 1.031 -0.997 1.031 -1.75v-3.5c0 -1.19347 -0.47411 -2.33807 -1.31802 -3.18198C5.58807 4.72411 4.44347 4.25 3.25 4.25c-0.42675 0 -0.84726 0.06062 -1.25 0.17709V1.5c0 -0.39782 0.15804 -0.779356 0.43934 -1.06066Z"
            clipRule="evenodd"
            strokeWidth="1"
          ></path>
          <path
            id="Vector (Stroke)"
            fill="#5073c3"
            fillRule="evenodd"
            d="M3.25 7c-0.46413 0 -0.90925 0.18437 -1.23744 0.51256C1.68437 7.84075 1.5 8.28587 1.5 8.75V12c0 0.1326 0.05268 0.2598 0.14645 0.3536 0.09376 0.0937 0.22094 0.1464 0.35355 0.1464 0.13261 0 0.25979 -0.0527 0.35355 -0.1464 0.09377 -0.0938 0.14645 -0.221 0.14645 -0.3536V9.25c0 -0.41421 0.33579 -0.75 0.75 -0.75s0.75 0.33579 0.75 0.75V12c0 0.5304 -0.21071 1.0391 -0.58579 1.4142C3.03914 13.7893 2.53043 14 2 14s-1.039141 -0.2107 -1.414214 -0.5858C0.210714 13.0391 0 12.5304 0 12V8.75c0 -0.86195 0.34241 -1.6886 0.951903 -2.2981C1.5614 5.84241 2.38805 5.5 3.25 5.5c0.86195 0 1.6886 0.34241 2.2981 0.9519 0.60949 0.6095 0.9519 1.43615 0.9519 2.2981v3.5c0 0.4142 -0.33579 0.75 -0.75 0.75S5 12.6642 5 12.25v-3.5c0 -0.46413 -0.18437 -0.90925 -0.51256 -1.23744C4.15925 7.18437 3.71413 7 3.25 7Z"
            clipRule="evenodd"
            strokeWidth="1"
          ></path>
        </g>
      </svg>
    </SvgIcon>
  )
}

FileAttachmentIcon.propTypes = {
  sx: PropTypes.object
}
